module.exports = __webpack_public_path__ + "img/fivehundred.dd8e221e.png";